/**
 * Componente individual para renderizar cada sugerencia en la lista
 * Maneja la interacción táctil y de mouse para seleccionar sugerencias
 * 
 * @component
 * @param {Object} suggestion - Objeto con datos de la sugerencia
 * @param {string} suggestion.sugerencia - Texto original de la sugerencia
 * @param {string} suggestion.cleanText - Texto procesado para mostrar
 * @param {number} index - Índice de la sugerencia en la lista
 * @param {boolean} isSelected - Indica si esta sugerencia está seleccionada
 * @param {Function} onSelect - Callback ejecutado al seleccionar la sugerencia
 * 
 * @example
 * <SuggestionItem
 *   suggestion={{ sugerencia: "México", cleanText: "México" }}
 *   index={0}
 *   isSelected={true}
 *   onSelect={() => handleSelect("México")}
 * />
 */
export default function SuggestionItem({ suggestion, index, isSelected, onSelect }) {
  /**
   * Maneja el evento de click/touch en la sugerencia
   * Previene el comportamiento por defecto y ejecuta la selección
   * @param {Event} e - Evento de click o touch
   */
  const handleClick = (e) => {
    e.preventDefault();
    onSelect(); // Llamar sin parámetros
  };

  return (
    <li
      key={`${suggestion.sugerencia}-${index}`}
      id={`suggestion-${index}`}
      role="option"
      className={isSelected ? 'selected' : ''}
      onTouchEnd={handleClick}
      onMouseDown={handleClick}
      aria-selected={isSelected}
    >
      <span className='icon-search' aria-hidden='true'></span>
      {suggestion.cleanText}
    </li>
  )
};

